<div class="card" id="sale-payoff-modal">
    <div class="card-header">
        <h3 class="card-title">Payoff Sale</h3>
        @if (receivable) {
            <p class="card-subtitle text-muted">{{receivable.contact}} | {{receivable.vehicle}}</p>
        }
    </div>
    <div class="card-body">
        <form [formGroup]="form">
            <div class="form-row">
                <label for="last" class="col-5 col-form-label">
                    @if (receivable && receivable.prevPaymentDate) {
                        Date of Last Payment
                    }
                    @else {
                        Date Sold
                    }
                </label>
                <div class="col">
                    <input type="date" id="last" class="form-control form-control-sm" formControlName="last" />
                </div>
            </div>
            <div class="form-row">
                <label for="when" class="col-5 col-form-label">Date Paid Off</label>
                <div class="col">
                    <input type="date" id="when" class="form-control form-control-sm" formControlName="when" />
                </div>
            </div>
            <div class="form-row">
                <label for="discount" class="col-5 col-form-label">Payoff Discount</label>
                <div class="col">
                    <currency-input id="discount" [control]="form.get('discount')"></currency-input>
                </div>
            </div>
        </form>
    </div>
    <div class="card-footer">
        <div class="button-bar">
            <button type="button" class="btn btn-sm btn-link" data-dismiss="modal"><span class="text-muted">{{words[language][ 'cancel' ] | lowercase}}</span></button>
            <button type="button" class="btn btn-sm btn-primary" [disabled]="processing" (click)="payoff($event)">Mark as Paid Off</button>
        </div>
    </div>
</div>